<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6969_24038)">
      <path
        d="M4 17C4 18.1 4.9 19 6 19H14C15.1 19 16 18.1 16 17V5L4 5L4 17ZM17 2L13.5 2L12.5 1L7.5 1L6.5 2L3 2L3 4L17 4V2Z"
        fill="#9CA3AF"
      />
    </g>
    <defs>
      <clipPath id="clip0_6969_24038">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
